// src/pages/Transactions/TransactionFilters.jsx
import React from 'react';
import { transactionStyles } from './styles';

// SVG Icons
const AllIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <line x1="9" y1="9" x2="15" y2="9" />
    <line x1="9" y1="15" x2="15" y2="15" />
  </svg>
);

const ShoppingBagIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <path d="M16 10a4 4 0 0 1-8 0" />
  </svg>
);

const DollarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

const TransactionFilters = ({ filter, setFilter }) => {
  const filters = [
    { key: 'all', label: 'All Orders', icon: <AllIcon /> },
    { key: 'purchases', label: 'My Purchases', icon: <ShoppingBagIcon /> },
    { key: 'sales', label: 'My Sales', icon: <DollarIcon /> }
  ];

  return (
    <div style={transactionStyles.filtersContainer}>
      <div style={transactionStyles.filters}>
        {filters.map(({ key, label, icon }) => (
          <button 
            key={key}
            onClick={() => setFilter(key)}
            style={{
              ...transactionStyles.filterButton,
              ...(filter === key ? transactionStyles.filterButtonActive : {})
            }}
          >
            <span style={transactionStyles.filterIcon}>{icon}</span>
            <span>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TransactionFilters;